import { render, staticRenderFns } from "./OrmBatchingViewSideMenu.vue?vue&type=template&id=7c6b68b4"
import script from "./OrmBatchingViewSideMenu.vue?vue&type=script&lang=js"
export * from "./OrmBatchingViewSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c6b68b4')) {
      api.createRecord('7c6b68b4', component.options)
    } else {
      api.reload('7c6b68b4', component.options)
    }
    module.hot.accept("./OrmBatchingViewSideMenu.vue?vue&type=template&id=7c6b68b4", function () {
      api.rerender('7c6b68b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormbatching/OrmBatchingViewSideMenu.vue"
export default component.exports